import { lazyGettext } from '@eb/lazy-gettext';

export const NOTIFICATION_BAR_LABEL = lazyGettext(
    'Need to make some updates? ',
);
export const EDIT_ORGANIZER_PROFILE = lazyGettext('Edit organizer profile');
